<script setup lang="ts">
import { ref, useSlots } from 'vue';

import Menu from 'primevue/menu';
import IconThreeDotsBold from '@icons/ph_three-dots-bold.svg';
import Icon from '../../_01_atoms/components/Icon.vue';
import Button from '../../_01_atoms/components/Button.vue';

const slots = useSlots();
const hasSlot = (slot: string): boolean => !!slots[slot];

const menu = ref();
const menuOptions = ref({
  root: { class: 'dropdown-ubiq' },
});

const toggle = (event: PointerEvent) => {
  menu.value.toggle(event);
};
</script>

<template>
  <div class="center">
    <slot v-if="hasSlot('actionner')" name="actionner" />
    <Button v-else variant="invisible" @click.prevent="toggle">
      <Icon :svg="IconThreeDotsBold" />
    </Button>
    <Menu ref="menu" popup :pt="menuOptions">
      <template #start>
        <slot name="start" />
      </template>
      <template #item>
        <slot name="item" />
      </template>
      <template #end>
        <slot name="end" />
      </template>
    </Menu>
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

button {
  width: fit-content;
  height: rem(24);
  padding: 0 rem(2);

  @media (hover: hover) {
    &:hover {
      background: $colorGray;
    }
  }
}
</style>
